
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card background-color-wt">
      <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

        <div class="row">
          <div class="col-print-12 text-align-center">
            <label class="font-familyhead">FET</label>
            <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style8" [qrdata]="FormattedCode" [size]="90" [level]="'M'"></qrcode>-->
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <!--<div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Owner}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Gender}}/{{Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{FormattedCode}}</label>
                </div>
              </div>-->
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Cycle:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CycleType}} ({{CycleNo}})</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol Start:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocolst | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Infertility Type:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Infertility}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Donor:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorData}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocol}}</label>
                </div>
              </div>
              
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol End:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolEd | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Donor ID:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorCode}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <!--<div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal">{{TitleText}}</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>-->
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold">Stored Embryos</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
       
        <div class="col-print-12">
          <div class="row margin-left-0px">

            <div class="col-print-11">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">

                    <tr>
                      <!--<th rowspan="5" class="font-weight-normal background-primary padding-top-2px text-align-center padding-bottom-2px font-family">

  </th>-->

                      <th class="font-weight-normal background-primary padding-top-2px text-align-center padding-bottom-2px font-family">
                        Treatment Cycle &amp; Date
                      </th>

                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                        Cell Stage (or) Embryo Stage
                      </th>

                      <th class="font-weight-normal background-primary padding-top-2px text-align-center padding-bottom-2px font-family">
                        Straw#
                      </th>

                      <th class="font-weight-normal background-primary padding-top-2px text-align-center padding-bottom-2px font-family">
                        Old Grade
                      </th>

                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                        New Grade
                      </th>

                      <th class="font-weight-normal background-primary padding-top-2px text-align-center padding-bottom-2px font-family">
                        Transfer Count
                      </th>


                    </tr>

                    <tr *ngFor="let l of CurrentEmbryosFromStoreController">
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.TreatmentCycle}} &amp; {{l.Date|date:'MMM-dd-yyyy'}}
                      </td>                      
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.CellStage}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.StrawNumber}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.Grade}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.Regrade}}{{l.Regrade2}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.Count}}
                      </td>
                     
                    </tr>

                

                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

  


      </div>
    </div>
  </div>
</div>

